import { render } from "./SubsidiesRows.vue?vue&type=template&id=19e8d368&scoped=true"
import script from "./SubsidiesRows.vue?vue&type=script&lang=js"
export * from "./SubsidiesRows.vue?vue&type=script&lang=js"

import "./SubsidiesRows.vue?vue&type=style&index=0&id=19e8d368&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e8d368"]])

export default __exports__